import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, inject, Injectable, Signal } from '@angular/core';
import { WorkGridItemObject } from '@it2go/types';
import { localDate } from '../../../../../modules/shared/pipes/local-date.pipe';
import {
    WorkDataContinuousRecordObject,
} from '@libs/types/src/services/object-type/work/work-data-continuous-record.object';
import { SessionService } from '../../../../../services/session.service';
import { formatPerson } from '@libs/shared/helpers/person.utils';

@Injectable()
export class FolderContinuousRecordStore extends ComponentStoreV2Factory {

    protected readonly session = inject(SessionService);

    public workRecords: Signal<WorkGridItemObject<WorkDataContinuousRecordObject>[]> = computed(() => {
        const works = this.data.getWorks()?.['items'] || [];
        return works.map((item: WorkGridItemObject<WorkDataContinuousRecordObject>, index: number) => {
            const createdAt = localDate(item.dateFrom, this.session);
            return {
                ...item,
                data: item.workData?.data || '',
                createdAt,
                index,
                key: createdAt + ' ' + formatPerson(item.users[0]),
            };
        });
    });
}
